import { render, staticRenderFns } from "./RequestDataProvider.vue?vue&type=template&id=70774f75&"
import script from "./RequestDataProvider.vue?vue&type=script&lang=js&"
export * from "./RequestDataProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports